import {
	UPDATE_GLOBAL_LLM_CONFIGURATION,
	UPDATE_GLOBAL_LLM_CONFIGURATION_SUCCESS,
	UPDATE_GLOBAL_LLM_CONFIGURATION_FAIL,
	UPDATE_GLOBAL_LLM_CONFIGURATION_RESET,
} from '../actions/updateGlobalLLMConfigurationAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const updateGlobalLLMConfigurationReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_GLOBAL_LLM_CONFIGURATION:
			return {
				...state,
				apiState: 'loading',
			};
		case UPDATE_GLOBAL_LLM_CONFIGURATION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case UPDATE_GLOBAL_LLM_CONFIGURATION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case UPDATE_GLOBAL_LLM_CONFIGURATION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default updateGlobalLLMConfigurationReducer;

